// Haptic feedback, used sparingly.
//
// Three rules govern where this is allowed to fire:
//
//   Causality — it goes on the event that caused it (the layer landing, the
//               edge catching), never on a timer near it.
//   Harmony   — it fires on the same frame as the visual change, or the two
//               come apart and the illusion goes with them.
//   Utility   — only moments that mean something. Buzzing on everything trains
//               people to stop noticing any of it.
//
// Vibration is unsupported on desktop browsers and on iOS Safari, so every call
// is a no-op there rather than a feature that half works.

const supported = () => typeof navigator !== "undefined" && typeof navigator.vibrate === "function"

// Someone who has asked for less motion has not necessarily asked for less
// touch feedback — but a haptic paired with motion that no longer happens is
// feedback for an event they cannot see, so it goes quiet too.
const wanted = () => supported() && !window.matchMedia("(prefers-reduced-motion: reduce)").matches

// An edge caught, a value clicked into place.
export function detent() {
  if (wanted()) navigator.vibrate(8)
}

// Something the user moved has landed and been committed.
export function landed() {
  if (wanted()) navigator.vibrate(12)
}

// Something left the screen for good.
export function dismissed() {
  if (wanted()) navigator.vibrate([0, 6, 30, 10])
}
